import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout file for /setup/service-roles/* — exists so the index route (the list)
// and the $id route (the detail/edit) can both nest under a common parent.
// Currently no shared chrome; just renders the matched child.
export const Route = createFileRoute('/_authenticated/setup/service-roles')({
  component: () => <Outlet />,
});
